import { useState, useEffect } from 'react'
import { getJwtToken } from '@edge/spark/io-aws'
import { env } from '@edge/env'
import useAuctionId from './useAuctionId'

const reportsVersion = env.REACT_APP_REPORTS_VERSION
const jasperBaseUrl =
    reportsVersion > 6 ? env.REACT_APP_REPORT_BASE_URL : `${env.REACT_APP_REPORT_BASE_URL}/j_spring_security_check`

const useJasperUrl = (auctionId: string) => {
    if (env.REACT_APP_REPORT_BASE_URL === undefined) {
        throw new Error('REACT_APP_REPORT_BASE_URL is undefined')
    }
    const [url, setUrl] = useState('')

    // We need to generate the jasper url each time any action is done with the BI link, to ensure that the
    // token being used is valid.  Using the current date to ensure the below effect will fire.
    const currentDate = new Date().toISOString()

    useEffect(() => {
        ;(async () => {
            try {
                const jasperToken = await getJwtToken()
                const nextUrl = jasperBaseUrl
                    ? `${jasperBaseUrl}?pipelineId=${auctionId}&accessToken=${jasperToken}`
                    : undefined
                if (nextUrl && nextUrl !== url) {
                    setUrl(nextUrl)
                }
            } catch (e) {
                console.log('useJasperUrl error', e)
                setUrl('')
            }
        })()
    }, [currentDate, auctionId])

    return url
}

export default useJasperUrl
